import React, { useState } from 'react';
import { Table, Input, Button, Space, Typography, Row, Col, Card, Divider, message } from 'antd';
import { MinusOutlined, PlusOutlined, DeleteOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { useCartContext } from 'contexts/CartContext';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Checkout = () => {
    const { cartItems, updateCartItem, removeFromCart } = useCartContext();
    const [discountCode, setDiscountCode] = useState('');
    const [appliedDiscount, setAppliedDiscount] = useState(0);
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate("/checkout");
    };

    const handleQuantityChange = (id, change) => {
        const item = cartItems.find(item => item.id === id);
        const newQuantity = Math.max(1, Math.min(item.quantity + change, 99));
        updateCartItem(id, newQuantity);
    };

    const handleRemoveItem = (id) => {
        removeFromCart(id);
    };

    const applyDiscountCode = () => {
        // Example discount logic
        if (discountCode === 'DISCOUNT10') {
            setAppliedDiscount(10);
        } else {
            message.error('Invalid discount code');
        }
    };

    const columns = [
        {
            title: 'Products',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Space>
                    <img src={record.images[0]} alt={text} style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: '8px' }} />
                    <Space direction="vertical" size={0}>
                        <Text strong>{text}</Text>
                        <Text type="secondary">Size: {record.size}</Text>
                    </Space>
                </Space>
            ),
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: price => <Text strong>${price.toFixed(2)}</Text>,
        },
        {
            title: 'Quantity',
            key: 'quantity',
            render: (_, record) => (
                <Space>
                    <Button icon={<MinusOutlined />} onClick={() => handleQuantityChange(record.id, -1)} />
                    <Input value={record.quantity} style={{ width: 50, textAlign: 'center' }} readOnly />
                    <Button icon={<PlusOutlined />} onClick={() => handleQuantityChange(record.id, 1)} />
                </Space>
            ),
        },
        {
            title: 'Subtotal',
            key: 'subtotal',
            render: (_, record) => <Text strong>${(record.price * record.quantity).toFixed(2)}</Text>,
        },
        {
            key: 'action',
            render: (_, record) => (
                <Button icon={<DeleteOutlined />} onClick={() => handleRemoveItem(record.id)} danger />
            ),
        },
    ];

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const deliveryCharge = 5.00;
    const grandTotal = subtotal + deliveryCharge - appliedDiscount;

    return (
        <div className='container' style={{ padding: '24px 0' }}>
            <Title level={2}><ShoppingCartOutlined /> Checkout</Title>
            <Row gutter={[24, 24]}>
                <Col xs={24} lg={16}>
                    <Table columns={columns} dataSource={cartItems.map(item => ({ ...item, key: item.id }))} pagination={false} scroll={{ x: true }} />
                </Col>
                <Col xs={24} lg={8}>
                    <Card>
                        <Space direction="vertical" style={{ width: '100%' }} size="large">
                            <div>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Text>Subtotal</Text>
                                        <Text strong>${subtotal.toFixed(2)}</Text>
                                    </div>
                                    <Divider />
                                    <div>
                                        <Text strong>Discount Code</Text>
                                        <Space.Compact style={{ width: '100%', marginTop: '8px' }}>
                                            <Input placeholder="Enter code" value={discountCode} onChange={(e) => setDiscountCode(e.target.value)} size='large' />
                                            <Button type="primary" size='large' onClick={applyDiscountCode}>Apply</Button>
                                        </Space.Compact>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Text>Delivery Charge</Text>
                                        <Text>${deliveryCharge.toFixed(2)}</Text>
                                    </div>
                                    <Divider />
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Text strong>Grand Total</Text>
                                        <Text strong style={{ fontSize: '18px', color: '#1890ff' }}>${grandTotal.toFixed(2)}</Text>
                                    </div>
                                </Space>
                            </div>
                            <Button type="primary" block size="large" style={{ marginTop: '16px' }} onClick={handleNavigate}>
                                Proceed to Checkout
                            </Button>
                        </Space>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Checkout;